import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#093125",
            color: "#F2EDE1",
            border: "1px solid rgba(166,135,78,0.35)",
            fontFamily: "'Montserrat', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
